import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Typography } from '../../../../../core/components/molecules/Typography';
import { Button } from '../../../../../core/components/atoms/Button';
import { Icon } from '../../../../../core/components/atoms/Icon';

const ModalWrapper = ({
  open,
  onClose,
  children,
}: {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}) => {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div
      className='fixed inset-0 z-[9999] flex items-center justify-center bg-mono-color-black/50 backdrop-blur-sm'
      onClick={onClose}
    >
      <div
        className='dark:bg-brand-color-primary-dark flex max-h-[90vh] w-full max-w-[1264px] flex-col rounded-lg bg-card-color-default shadow-level-1'
        onClick={(e) => e.stopPropagation()}
      >
        {/* Body com scroll */}
        <div className='flex-1 overflow-y-auto p-4'>{children}</div>

        {/* Footer fixo */}
        <div className='sticky bottom-0 h-10 rounded-b-lg bg-mono-color-lightest'>
          <div className='flex h-full items-center justify-between px-5'>
            <Typography className='text-color-darker'>Flashcards</Typography>
            <Button
              allowReadOnly
              variant='text'
              className='flex items-center justify-between gap-2 p-0 text-color-darker'
              onClick={onClose}
            >
              Ocultar
              <Icon
                Icon={'keyboard_arrow_up'}
                type='material'
                className='text-color-darker'
              />
            </Button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};
export default ModalWrapper;
